'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BaseNumber = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var ReactDOM = _interopRequireWildcard(_reactDom);

var _BaseInput2 = require('./BaseInput');

var _BaseInput3 = _interopRequireDefault(_BaseInput2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactLayoutComponents = require('react-layout-components');

var _reactRenderDebugger = require('react-render-debugger');

var _reactRenderDebugger2 = _interopRequireDefault(_reactRenderDebugger);

var _reactBootstrap = require('react-bootstrap');

var _redux = require('redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = require('classnames');

var BaseNumber = exports.BaseNumber = (_temp = _class = function (_BaseInput) {
	_inherits(BaseNumber, _BaseInput);

	function BaseNumber(props) {
		_classCallCheck(this, BaseNumber);

		// this.state = {
		// 	val_string: this.formatInitialValue(this.props.value),
		// 	display_string: this.formatInitialValue(this.props.value),
		// 	has_focus: false,
		// };

		var _this = _possibleConstructorReturn(this, (BaseNumber.__proto__ || Object.getPrototypeOf(BaseNumber)).call(this, props));

		var int_value = _this.props.value * Math.pow(10, _this.props.decimals);

		_this.state = {
			int_val: int_value,
			display_string: _this.makeIntToString(int_value),
			has_focus: false
		};
		return _this;
	}

	_createClass(BaseNumber, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (!nextProps.ignoreValueUpdates) {
				if (nextProps.value !== undefined) {
					if (nextProps.value !== this.props.value) {
						var int_value = nextProps.value * Math.pow(10, this.props.decimals);

						this.setState({
							int_val: int_value,
							display_string: this.makeIntToString(int_value)
						});
					}
				}
			}
		}
	}, {
		key: 'getRealValue',
		value: function getRealValue() {
			var temp_val = this.state.int_val / Math.pow(10, this.props.decimals);
			return parseFloat(temp_val);
		}
	}, {
		key: 'makeIntToString',
		value: function makeIntToString(int_val) {
			var debugVal = this.placeSeparator(int_val.toString());
			if (this.props.showSign) {
				if (int_val > 0) {
					debugVal = '+' + debugVal;
				}
			}
			return debugVal;
		}
	}, {
		key: 'getMinMaxCondition',
		value: function getMinMaxCondition(float_val) {
			if (this.props.max == null && this.props.min == null) {
				return true;
			} else if (this.props.max == null) {
				var min = this.props.min;
				if (typeof min != 'Number') {
					min = parseFloat(min);
				}
				return float_val >= min;
			} else if (this.props.min == null) {
				var max = this.props.max;
				if (typeof max != 'Number') {
					max = parseFloat(max);
				}
				return float_val <= max;
			} else {
				var _min = this.props.min;
				if (typeof _min != 'Number') {
					_min = parseFloat(_min);
				}
				var _max = this.props.max;
				if (typeof _max != 'Number') {
					_max = parseFloat(_max);
				}
				return float_val <= _max && float_val >= _min;
			}
		}

		// intValueFromInitialValue() {
		// 	const v = this.props.value*(10**this.props.decimals);
		// 	console.log(v)
		// 	return v
		// }

		// formatInitialValue(val) {
		// 	if (val === '') {
		// 		return '';
		// 	}
		// 	let float_val = Math.round(parseFloat(val) * (10 ** this.props.decimals));
		// 	if (float_val == 0) {
		// 		if (this.props.decimals == 0) {
		// 			return '0';
		// 		}
		// 		return '0' + this.props.decimalSeparator + '0'.repeat(this.props.decimals);
		// 	}
		//
		// 	let int_val = parseInt(float_val);
		// 	let ret = this.placeSeparator(int_val);
		// 	if (this.props.showSign) {
		// 		ret = '+' + ret;
		// 	}
		// 	return ret;
		// }

	}, {
		key: 'placeSeparator',
		value: function placeSeparator(val) {
			var string_val = val.toString();
			if (this.props.decimals == 0) {
				string_val = string_val.replace('.', '');
				string_val = string_val.replace(',', '');
				return string_val;
			}
			if (string_val.length > this.props.decimals) {
				var separator_position = string_val.length - this.props.decimals;
				string_val = string_val.slice(0, separator_position) + this.props.decimalSeparator + string_val.slice(separator_position);
				if (string_val.indexOf('-,') != -1 || string_val.indexOf('-.') != -1) {
					string_val = string_val.replace('-.', '-0.');
					string_val = string_val.replace('-,', '-0,');
				}
				return string_val;
			} else if (string_val.length <= this.props.decimals) {
				var ret = void 0;
				if (val >= 0) {
					var zeros = '';
					for (var i = string_val.length; i < this.props.decimals; i++) {
						zeros = zeros + '0';
					}
					return ret = '0' + this.props.decimalSeparator + zeros + val;
				} else {
					var _zeros = '';
					string_val = string_val.replace("-", "");
					for (var _i = string_val.length; _i < this.props.decimals; _i++) {
						_zeros = _zeros + '0';
					}
					val = val * -1;
					return ret = '-0' + this.props.decimalSeparator + _zeros + val;
				}
			}
		}
	}, {
		key: 'makeStringToInt',
		value: function makeStringToInt(val) {
			val = val.replace(',', '.');
			var temp = val.replace('.', '');
			var int_val = parseInt(temp);
			if (!isNaN(int_val)) {
				return int_val;
			} else {
				return 0;
			}
		}
	}, {
		key: 'formatToString',
		value: function formatToString(val) {
			var val_string = this.placeSeparator(val);
			if (this.props.showSign) {
				if (val > 0) {
					val_string = '+' + val_string;
				}
			}
			return val_string;
		}
	}, {
		key: 'setVal',
		value: function setVal(int_val) {
			var _this2 = this;

			var val_string = this.formatToString(int_val);
			// val_string = val_string.replace(',', '.');
			var float_val = parseFloat(val_string.replace(',', '.'));

			var min_max_bool = this.getMinMaxCondition(float_val);

			var step_bool = this.getStepCondition(float_val);
			if (min_max_bool && step_bool) {
				_bluebird2.default.resolve(this.setState({
					int_val: int_val,
					display_string: this.makeIntToString(int_val)
				})).then(function () {
					if (_this2.props.onChange != null) {
						_this2.props.onChange(float_val);
					}
				});
			} else {
				_bluebird2.default.resolve(this.setState({
					display_string: val_string
				})).then(function () {
					if (_this2.props.onChange != null) {
						_this2.props.esFormField.setValid(_this2.getRealValue(), false);
					}
				});
			}
		}
	}, {
		key: 'getStepCondition',
		value: function getStepCondition(val) {
			if (this.props.decimals >= 0) {
				return true;
			}
			return val % this.props.step == 0;
		}

		// getValidationResult(float_val) {
		// 	return true
		// }

	}, {
		key: 'handleOnFocus',
		value: function handleOnFocus(e) {
			var target = this.refs.inputField;
			target.selectionStart = 0;
			target.selectionEnd = target.value.length;
			this.props.onFocus();
			this.setState({ has_focus: true });
		}
	}, {
		key: 'handleOnChange',
		value: function handleOnChange(e) {
			e.persist();
			var int_val = this.makeStringToInt(e.target.value);

			this.setVal(int_val);

			// if (e.target.value == '') {
			// 	this.setState({
			// 		display_string: '',
			// 	});
			// } else {
			// 	let int_val = this.makeStringToInt(e.target.value);
			// 	this.setVal(int_val);
			// }
		}
	}, {
		key: 'handleOnKeyDown',
		value: function handleOnKeyDown(e) {
			e.persist();
			if (e.key == 'ArrowUp') {
				e.preventDefault();
				var int_val = this.state.int_val;
				// let int_val = this.makeStringToInt(this.state.val_string);
				int_val = int_val + this.props.step * Math.pow(10, this.props.decimals);
				this.setVal(int_val);
			} else if (e.key == 'ArrowDown') {
				e.preventDefault();
				var _int_val = this.state.int_val;
				// let int_val = this.makeStringToInt(this.state.val_string);
				_int_val = _int_val - this.props.step * Math.pow(10, this.props.decimals);
				this.setVal(_int_val);
			} else if (e.key == '-') {
				e.preventDefault();
				var temp = e.target.value;
				temp = temp.replace(',', '.');
				temp = temp.replace('.', '');
				temp = parseFloat(temp);
				temp = temp * -1;
				this.setVal(temp);
				//
				// if (this.props.min >= 0) {
				// 	if (temp <= 0) {
				// 		return
				// 	} else {
				// 		this.setVal(temp);
				// 	}
				// } else if (this.props.max <= 0) {
				// 	if (temp >= 0) {
				// 		return
				// 	} else {
				// 		this.setVal(temp);
				// 	}
				// } else {
				// 	this.setVal(temp);
				// }

				//	Enter
			} else if (e.keyCode === 13) {
				this.props.onEnter(this.getRealValue());
			}
			//ctrl + v
			else if (e.ctrlKey && e.keyCode == 86) {
					return;
					//ctrl + x
				} else if (e.ctrlKey && e.keyCode == 88) {
					return;
					//ctrl + c
				} else if (e.ctrlKey && e.keyCode == 67) {
					return;
					//ctrl + a
				} else if (e.ctrlKey && e.keyCode == 65) {
					return;
				}

			if (this.props.controlKeys.indexOf(e.key) == -1) {
				var reg = RegExp(this.props.allowedCharacters);
				if (!reg.test(e.key)) {
					e.preventDefault();
				}
			}
		}
	}, {
		key: 'handleOnBlur',
		value: function handleOnBlur(e) {
			var _this3 = this;

			_bluebird2.default.resolve(this.setState({
				has_focus: false,
				display_string: this.makeIntToString(this.state.int_val)
			})).then(function () {
				_this3.props.esFormField.setValid(_this3.getRealValue(), _this3.props.esFormField.isValid(_this3.getRealValue()));
				// if (this.props.onChange == null) {
				//
				// }
			});
		}
	}, {
		key: 'handleOnPaste',
		value: function handleOnPaste(e) {
			e.preventDefault();
			var temp = e.clipboardData.getData('text');
			temp = temp.replace(',', '.');

			if (!isNaN(parseFloat(temp))) {
				temp = parseFloat(temp);
				temp = temp.toFixed(this.props.decimals);
				temp = parseInt(temp.replace(".", ""));
				this.setVal(temp);
			}
		}
	}, {
		key: 'handleOnWheel',
		value: function handleOnWheel(e) {
			e.preventDefault();

			if (this.props.noWheel) return null;

			var int_val = this.state.int_val;
			if (e.deltaY <= -50) {
				int_val = int_val + this.props.step * Math.pow(10, this.props.decimals);
			}
			if (e.deltaY >= 50) {
				int_val = int_val - this.props.step * Math.pow(10, this.props.decimals);
			}

			this.setVal(int_val);
		}
	}, {
		key: 'handleOnInputFocus',
		value: function handleOnInputFocus(e) {
			ReactDOM.findDOMNode(this.refs.inputField).focus();
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(e) {
			e.target.select();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var UnsetWidth = false;
			if (this.props.size !== null) {
				UnsetWidth = true;
			}

			var display_string = this.state.display_string;
			if (this.props.disabled) {
				display_string = "";
			}

			return _react2.default.createElement(
				_reactLayoutComponents.Box,
				{ row: true,
					className: classnames('ESInput Number form-control', {
						'input-sm': this.props.bsSize != null && this.props.bsSize == 'sm',
						'input-lg': this.props.bsSize != null && this.props.bsSize == 'lg'
					}, {
						focus: this.state.has_focus
					}, { disabled: this.props.disabled }, { "UnsetWidth": UnsetWidth }),
					onClick: this.handleOnInputFocus.bind(this),
					ref: function ref(i) {
						return _this4.outerBox = i;
					},
					id: 'myTextField'
				},
				this.renderPrefix(),
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ fit: !UnsetWidth, className: classnames('Input', { "UnsetWidth": UnsetWidth }) },
					_react2.default.createElement('input', {
						name: this.props.fieldName,
						className: classnames({ "UnsetWidth": UnsetWidth }),

						disabled: this.props.disabled,
						ref: 'inputField',
						type: this.props.htmlInputType,
						readOnly: this.props.readOnly,
						value: display_string,
						onPaste: function onPaste(e) {
							return _this4.handleOnPaste(e);
						}
						// onFocus={(e) => this.handleOnFocus(e)}
						, onChange: function onChange(e) {
							return _this4.handleOnChange(e);
						},
						onKeyDown: function onKeyDown(e) {
							return _this4.handleOnKeyDown(e);
						}
						// onWheel={(e) => {
						// 	this.handleOnWheel(e);
						// }}
						, onFocus: this.handleInputFocus.bind(this),
						onBlur: this.handleOnBlur.bind(this),
						size: this.props.size,
						maxLength: this.props.maxLength
					})
				),
				this.renderSuffix()
			);
		}
	}, {
		key: 'renderPrefix',
		value: function renderPrefix() {
			if (this.props.prefix == '') return null;
			return _react2.default.createElement(_reactLayoutComponents.Box, { className: 'Prefix', dangerouslySetInnerHTML: { __html: this.props.prefix } });
		}
	}, {
		key: 'renderSuffix',
		value: function renderSuffix() {
			if (this.props.suffix == '') return null;
			if (this.props.hideSuffix) return null;

			return _react2.default.createElement(_reactLayoutComponents.Box, { className: 'Suffix', dangerouslySetInnerHTML: { __html: this.props.suffix } });
		}
	}]);

	return BaseNumber;
}(_BaseInput3.default), _class.defaultProps = Object.assign({}, _BaseInput3.default.defaultProps, {
	value: 0,
	allowedCharacters: '[0-9.,]',
	decimals: 0,
	decimalSeparator: ',',
	max: 65536,
	step: 1,
	prefix: '',
	suffix: '',
	onFocus: function onFocus() {},
	noWheel: false,
	ignoreValueUpdates: false,
	htmlInputType: "text"
}), _class.propTypes = Object.assign({}, _BaseInput3.default.propTypes, {
	allowedCharacters: _propTypes2.default.string,
	decimals: _propTypes2.default.number,
	decimalSeparator: _propTypes2.default.string,
	min: _propTypes2.default.number,
	max: _propTypes2.default.number,
	step: _propTypes2.default.number,
	prefix: _propTypes2.default.string,
	suffix: _propTypes2.default.string,
	onFocus: _propTypes2.default.func,
	noWheel: _propTypes2.default.bool,
	ignoreValueUpdates: _propTypes2.default.bool,
	htmlInputType: _propTypes2.default.string
}), _temp);
exports.default = (0, _redux.compose)()(BaseNumber);